import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { getTranslate } from '../../../utils/getTranslate/getTranslate';
import { getRandomArray } from '../../../utils/getRandomArray/getRandomArray';
import Lightbox from 'yet-another-react-lightbox';
import color from '../../../data/color/color.json';
import styles from '../Museum.module.scss';

export const Historia = ({ upPage }) => {
  const [open, setOpen] = useState(false);
  const [currentSlides, setCurrentSlides] = useState([]);
  const t = getTranslate;
  const { lang } = useParams();
  const { toptitle, title, text, items } = upPage.acf.historia;
  const upRanColArr = getRandomArray(color.length, items.length);

  const openImage = (imgUrl) => {
    setCurrentSlides([{ src: imgUrl }]);
    setOpen(true);
  };

  const openPdf = (pdfUrl) => {
    setCurrentSlides([
      {
        type: 'custom-pdf',
        src: pdfUrl,
      },
    ]);
    setOpen(true);
  };

  return (
    <section className={styles.historia}>
      <div className="container">
        <div className={styles.historia}>
          <h3 className={`${styles.historia_toptitle} global-subtitle`}>{toptitle[lang]}</h3>
          <h2 className={`${styles.historia_title} global-title`}>{title[lang]}</h2>
          <p className={`${styles.historia_text} global-text`}>{text[lang]}</p>
          <div className={styles.historia_row}>
            {items.map((el, idx) => {
              const { img, pdf, year, title, text } = el;
              return (
                <div key={idx} className={styles.historia_column}>
                  <div className={styles.historia_column_body}>
                    <div className={styles.historia_column_line}>
                      <div className={styles.hisiria_column_circle} style={{ background: color[upRanColArr[idx]] }}>
                        <div className={styles.hisiria_column_circle_body} style={{ border: `2px solid ${color[upRanColArr[idx]]}` }}>
                          <div className={styles.hisiria_column_circle_color} style={{ background: color[upRanColArr[idx]] }}></div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.historia_column_content}>
                      <div className={styles.historia_column_year} style={{ color: color[upRanColArr[idx]] }}>
                        {year}
                      </div>
                      <h3 className={styles.historia_column_title}>{title[lang]}</h3>
                      <p className={`${styles.historia_column_text} global-text`}>{text[lang]}</p>

                      {!!img && (
                        <div onClick={() => openImage(img)} className={styles.historia_column_btn}>
                          <span style={{ background: color[upRanColArr[idx]] }}></span>
                          {t('Суреттерді көру', 'Просмотр изображений', lang)}
                        </div>
                      )}

                      {!!pdf && (
                        <div onClick={() => openPdf(pdf)} className={styles.historia_column_btn}>
                          <span style={{ background: color[upRanColArr[idx]] }}></span>
                          {t('Pdf файлын қарау', 'Просмотр PDF файла', lang)}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <Lightbox
            open={open}
            close={() => setOpen(false)}
            index={0}
            slides={currentSlides}
            render={{
              slide: ({ slide }) => {
                return slide.type === 'custom-pdf' ? (
                  <div style={{ width: '80%', height: '90vh' }}>
                    <iframe src={`${slide.src}#toolbar=0`} width="100%" height="100%" title="PDF Viewer" frameBorder="0" />
                  </div>
                ) : undefined;
              },
              buttonPrev: () => null,
              buttonNext: () => null,
            }}
            carousel={{ finite: true, draggable: false, swipeable: false }}
          />
        </div>
      </div>
    </section>
  );
};
